import React from 'react';
import { projects } from './data/content';
import './css/Projects.css';

const Projects: React.FC = () => {
  return (
    <section className="projects" id="projects">
      <div className="container">
        <div className="section-header fade-in">
          <div className="section-tag">// Our Work</div>
          <h2>Featured Projects</h2>
          <p>Real-world solutions delivering measurable business impact</p>
        </div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card fade-in">
              <div className="project-image">{project.icon}</div>
              <div className="project-content">
                <div className="project-tags">
                  {project.tags.map((tag, idx) => (
                    <span key={idx} className="tag">{tag}</span>
                  ))}
                </div>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="project-links">
                  <a href={project.link} className="project-link" target="_blank" rel="noopener noreferrer">
                    View Case Study →
                  </a>
                  {project.visitUrl && (
                    <a href={project.visitUrl} className="project-link" target="_blank" rel="noopener noreferrer">
                      Visit Site →
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
